module.exports = __webpack_public_path__ + "static/media/Leaf_Youth_square.f267b3af.png";